import "./style.scss";

import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Tooltip } from "@mui/material";
import { displayMobileNavBtn } from "components/shared/BPMobileNavBtn";
import type { TMissingInfos } from "components/shared/BPNavigationBarSettings";
import { SmallBody, SmallBodyHighlight, TinyBody } from "helpers/TypographyComponents";
import { useIsMobile } from "hooks/useIsMobile";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import MissingInfosModal from "./MissingInfosModal";

interface IMissingInfosWarning {
    tooltipTitle?: string;
    /**
     * Missing informations fields
     */
    missingInfos?: TMissingInfos;
    /**
     * From which page the modal is called
     */
    from: "account" | "tax" | "settings-nav";
}

/**
 * Yellow Warning used in BP portal settings, when a beneficiary got invited to complete his profile
 * and when some mandatory informations are missing.
 *
 * That component include a modal to show misisng infos for mobile / tablet users.
 */
const MissingInfosWarning = ({ tooltipTitle, missingInfos, from }: IMissingInfosWarning) => {
    const [t] = useTranslation();
    const { isMobile } = useIsMobile();
    const [showMissingInfosModal, setShowMissingInfosModal] = useState(false);

    const openMissingInfosModal = () => {
        if (isMobile) {
            setShowMissingInfosModal(true);
            displayMobileNavBtn(false);
        } else return;
    };

    const closeMissingInfosModal = () => {
        setShowMissingInfosModal(false);
        displayMobileNavBtn(true);
    };

    return (
        <>
            <div className="bp-settings-info-missing" onClick={openMissingInfosModal}>
                <div className="bp-settings-info-missing-title" style={{ marginBottom: "0.25rem" }}>
                    <SmallBodyHighlight color="warning" style={{ fontSize: "13px" }}>
                        {t("NewBeneficiary.IncompleteProfile")}
                    </SmallBodyHighlight>
                    {isMobile ? (
                        <TinyBody color="warning">{t("Settings.PressForDetails")}</TinyBody>
                    ) : (
                        <Tooltip title={tooltipTitle}>
                            <div>
                                <TinyBody color="warning" style={{ fontWeight: "500", cursor: "pointer" }}>
                                    - {t("NewBeneficiary.ViewFields")}
                                </TinyBody>
                            </div>
                        </Tooltip>
                    )}
                </div>
                <SmallBody color="warning">{t("NewBeneficiary.IncompleteProfileDesc")} </SmallBody>
            </div>

            {/** Missing Infos Modal */}
            <MissingInfosModal
                open={showMissingInfosModal}
                onClose={closeMissingInfosModal}
                missingInfos={missingInfos}
                from={from}
            />
        </>
    );
};

export default MissingInfosWarning;
